
















import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ["data"]
})
export default class SFRadio extends Vue {}
